<ul
  class="gw-flex gw-flex-col gw-list-none gw-m-0 gw-p-0 gw-gap-2x-small gw-w-full"
  [class.gw-px-x-small]="depth === 0"
  [class.gw-pl-medium]="depth > 0"
>
  <li *ngFor="let item of items" class="gw-flex gw-flex-col gw-w-full">
    <!-- Branch: folder with children -->
    <ng-container *ngIf="item.subMenu?.length; else leafLink">
      <div class="gw-flex gw-min-w-0 gw-items-stretch gw-w-full">
        <a
          *ngIf="item.route; else branchButton"
          [routerLink]="item.route"
          (click)="sidebar.onLeafClick()"
          class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-min-h-[32px] gw-gap-2x-small gw-px-2x-small gw-py-4x-small gw-rounded-lg gw-no-underline gw-transition-colors gw-duration-200"
          [ngClass]="{
            'gw-bg-background-neutral-2 gw-text-text-primary':
              sidebar.isActiveItem(item),
            'gw-text-text-secondary hover:gw-bg-background-neutral-1-hover':
              !sidebar.isActiveItem(item)
          }"
        >
          <gatewee-icon
            [icon]="sidebar.itemIcon(item)"
            size="16px"
            class="gw-shrink-0"
          />
          <span
            *ngIf="!sidebar.isCollapsed"
            class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-sm gw-text-left"
            [attr.title]="sidebar.formatTitle(item.title)"
          >
            {{ sidebar.formatTitle(item.title) }}
          </span>
        </a>

        <ng-template #branchButton>
          <button
            type="button"
            (click)="sidebar.toggleExpand(item, $event)"
            class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-min-h-[32px] gw-gap-2x-small gw-px-2x-small gw-py-4x-small gw-rounded-lg gw-b-none gw-bg-transparent gw-cursor-pointer gw-transition-colors gw-duration-200"
            [ngClass]="{
              'gw-bg-background-neutral-2 gw-text-text-primary':
                sidebar.isBranchActive(item),
              'gw-text-text-secondary hover:gw-bg-background-neutral-1-hover':
                !sidebar.isBranchActive(item)
            }"
          >
            <gatewee-icon
              [icon]="sidebar.itemIcon(item)"
              size="16px"
              class="gw-shrink-0"
            />
            <span
              *ngIf="!sidebar.isCollapsed"
              class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-sm gw-text-left"
              [attr.title]="sidebar.formatTitle(item.title)"
            >
              {{ sidebar.formatTitle(item.title) }}
            </span>
          </button>
        </ng-template>

        <button
          *ngIf="!sidebar.isCollapsed"
          type="button"
          class="gw-flex gw-items-center gw-justify-center gw-min-w-[28px] gw-min-h-[32px] gw-rounded-lg gw-b-none gw-bg-transparent gw-cursor-pointer gw-text-text-tertiary hover:gw-bg-background-neutral-1-hover"
          (click)="sidebar.toggleExpand(item, $event)"
          [attr.aria-expanded]="sidebar.isExpanded(item)"
        >
          <gatewee-expand-chevron
            [expanded]="sidebar.isExpanded(item)"
            size="14px"
          />
        </button>
      </div>

      <div
        *ngIf="!sidebar.isCollapsed && sidebar.isExpanded(item)"
        class="gw-flex gw-flex-col"
      >
        <gatewee-doc-sidebar-node
          [items]="item.subMenu!"
          [depth]="depth + 1"
          [sidebar]="sidebar"
        />
      </div>
    </ng-container>

    <!-- Leaf: page link -->
    <ng-template #leafLink>
      <a
        *ngIf="item.route"
        [routerLink]="item.route"
        (click)="sidebar.onLeafClick()"
        class="gw-flex gw-min-w-0 gw-items-center gw-min-h-[32px] gw-gap-2x-small gw-px-2x-small gw-py-4x-small gw-rounded-lg gw-no-underline gw-transition-colors gw-duration-200"
        [ngClass]="{
          'gw-bg-background-neutral-2 gw-text-text-primary':
            sidebar.isActiveItem(item),
          'gw-text-text-secondary hover:gw-bg-background-neutral-1-hover':
            !sidebar.isActiveItem(item)
        }"
        [attr.title]="sidebar.formatTitle(item.title)"
      >
        <gatewee-icon
          [icon]="sidebar.itemIcon(item)"
          size="16px"
          class="gw-shrink-0"
        />
        <span
          *ngIf="!sidebar.isCollapsed"
          class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-sm gw-text-left"
        >
          {{ sidebar.formatTitle(item.title) }}
        </span>
      </a>
    </ng-template>
  </li>
</ul>
